import './css/HeaderRoles.css';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { useNavigate } from "react-router-dom";
import PerfilLogo from './usuarios/PerfilLogo';
import { useEffect, useRef } from 'react';
import axios from 'axios';

import CONFIG from '../config';
import { useFirebaseCounter } from '../hooks/useFirebaseCounter';

const URL_LISTAR_MENSAJES = `${CONFIG.API_URL}/listarMensajes.php`;
const URL_NOTI = `${CONFIG.API_URL}/operarNotificaciones.php`;

function HeaderRoles({
  acceder,
  rolSelect,
  configuracion,
  mensajesSinLeer,
  setMensajesSinLeer,
  notificacionesSinVer,
  setNotificacionesSinVer
}) {
  const navigate = useNavigate();
  const datosUser = JSON.parse(localStorage.getItem('loggeddatosuser') || '{}');
  const userId = datosUser?.id;
  const loggeduserNombre = localStorage.getItem('loggeduserNombre') || '';

  /* ===============================
     REFS PARA CONTROL DE NOTIFICACIONES
     =============================== */
  const mensajesInitRef = useRef(false);
  const ultimoMensajesSinLeerRef = useRef(0);

  const notiInitRef = useRef(false);
  const ultimaNotiSinVerRef = useRef(0);

  /* ===============================
     PERMISO DE NOTIFICACIONES
     =============================== */
  useEffect(() => {
    if ("Notification" in window && Notification.permission === "default") {
      Notification.requestPermission();
    }
  }, []);

  /* ===============================
     FETCH INICIAL DE CONTADORES
     =============================== */
  useEffect(() => {
    if (!userId) return;

    // Mensajes sin leer
    (async () => {
      try {
        const res = await axios.post(URL_LISTAR_MENSAJES, {
          id: userId,
          tipo: 'SIN_LEER'
        });
        if (!res.data?.error) {
          setMensajesSinLeer(res.data.cantidad || 0);
        }
      } catch (e) {
        console.error(e);
      }
    })();

    // Notificaciones sin ver
    (async () => {
      try {
        const res = await axios.post(URL_NOTI, {
          id: userId,
          modo: 'contador'
        });
        if (!res.data?.error) {
          setNotificacionesSinVer(res.data.cantidad || 0);
        }
      } catch (e) {
        console.error(e);
      }
    })();
  }, [userId]);

  /* ===============================
     FIREBASE - MENSAJES
     =============================== */
  useFirebaseCounter(
    userId ? `mensajes/user_${userId}` : null,
    async () => {
      try {
        const res = await axios.post(URL_LISTAR_MENSAJES, {
          id: userId,
          tipo: 'SIN_LEER'
        });
        if (!res.data?.error) {
          setMensajesSinLeer(res.data.cantidad || 0);
        }
      } catch (e) {
        console.error(e);
      }
    }
  );

  /* ===============================
     FIREBASE - NOTIFICACIONES
     =============================== */
  useFirebaseCounter(
    userId ? `notificaciones/user_${userId}` : null,
    async () => {
      try {
        const res = await axios.post(URL_NOTI, {
          id: userId,
          modo: 'contador'
        });
        if (!res.data?.error) {
          setNotificacionesSinVer(res.data.cantidad || 0);
        }
      } catch (e) {
        console.error(e);
      }
    }
  );

  /* ===============================
     NOTIFICAR MENSAJES NUEVOS
     =============================== */
  useEffect(() => {
    if (mensajesSinLeer == null) return;

    // Primer render / F5
    if (!mensajesInitRef.current) {
      ultimoMensajesSinLeerRef.current = mensajesSinLeer;
      mensajesInitRef.current = true;
      return;
    }

    // Aumentó → mensaje nuevo real
    if (mensajesSinLeer > ultimoMensajesSinLeerRef.current) {
      if ("Notification" in window && Notification.permission === "granted") {
        try {
          new Notification("Nuevo mensaje recibido", {
            body: "Tiene mensajes sin leer en su bandeja",
            icon: "/icono.png"
          });
        } catch (e) {
          console.error(e);
        }
      }
    }

    ultimoMensajesSinLeerRef.current = mensajesSinLeer;
  }, [mensajesSinLeer]);

  /* ===============================
     NOTIFICAR NOTIFICACIONES NUEVAS
     =============================== */
  useEffect(() => {
    if (notificacionesSinVer == null) return;

    // Primer render / F5
    if (!notiInitRef.current) {
      ultimaNotiSinVerRef.current = notificacionesSinVer;
      notiInitRef.current = true;
      return;
    }

    // Aumentó → notificación nueva real
    if (notificacionesSinVer > ultimaNotiSinVerRef.current) {
      if ("Notification" in window && Notification.permission === "granted") {
        try {
          new Notification("Nueva notificación", {
            body: "Tiene notificaciones pendientes",
            icon: "/icono.png"
          });
        } catch (e) {
          console.error(e);
        }
      }
    }

    ultimaNotiSinVerRef.current = notificacionesSinVer;
  }, [notificacionesSinVer]);

  /* ===============================
     ACCIONES
     =============================== */
  const handleLogout = () => {
    acceder(false);
    rolSelect(null);
    localStorage.clear();
    navigate("/");
  };

  const handleRol = () => {
    rolSelect(null);
    localStorage.removeItem("loggeduserRolId");
    navigate("/");
  };

  const title = (
    <PerfilLogo
      usuario={datosUser}
      configuracion={configuracion}
      version="logo_solo"
      habilitarModal={false}
    />
  );

  /* ===============================
     RENDER
     =============================== */
  return (
    <header
      id="header"
      className="fixed-top"
      style={{
        backgroundColor: configuracion.fondo_barra_superior,
        color: configuracion.color_texto_barra_superior
      }}
    >
      <Navbar>
        <Container>
          <Navbar.Brand>
            <span className="logo1">
              <img
                src={`${CONFIG.API_URL}/${configuracion.logo_chico}`}
                alt=""
                className="hidden-xs"
              />
            </span>
            {/* Texto SOLO en pantallas grandes */}
            <div className="ms-3 d-none d-lg-block">
              <div className="logo-texto" style={{ color: configuracion.color_primario }} >
                {configuracion.nombre} 
              </div>
              <div className="logo-texto" style={{ color: configuracion.color_primario }} >
                 {configuracion.sub_titulo}
              </div>
            </div>
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <div className="align-derecha">
              <Nav>
                {localStorage.getItem('loggeduserRolId') && (
                  <>
                    

                    <OverlayTrigger
                      placement="bottom"
                      overlay={<Tooltip>Mensajería interna</Tooltip>}
                    >
                      <Nav.Link
                        onClick={() => navigate('/Mensajes')}
                        className="mx-3"
                      >
                        <h4>
                          <i className="fa-solid fa-envelope"></i>
                          {mensajesSinLeer > 0 && (
                            <span className="info-mensajes-head text-white">
                              {mensajesSinLeer}
                            </span>
                          )}
                        </h4>
                      </Nav.Link>
                    </OverlayTrigger>
                  </>
                )}

                <OverlayTrigger
                  placement="bottom"
                  overlay={<Tooltip>{loggeduserNombre}</Tooltip>}
                >
                  <NavDropdown drop="start" title={title}>
                    <NavDropdown.Header>
                      {loggeduserNombre}
                    </NavDropdown.Header>
                    <NavDropdown.Divider />
                    <NavDropdown.Item onClick={() => navigate("/perfil")}>
                      <i className="fa-solid fa-user-pen"></i> Editar perfil
                    </NavDropdown.Item>
                    <NavDropdown.Item onClick={() => navigate("/Pass")}>
                      <i className="fa-solid fa-key"></i> Cambiar contraseña
                    </NavDropdown.Item>
                    <NavDropdown.Item onClick={handleRol}>
                      <i className="fa-solid fa-rotate"></i> Seleccionar rol
                    </NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item onClick={handleLogout}>
                      <i className="fa-solid fa-arrow-right-from-bracket"></i> Cerrar sesión
                    </NavDropdown.Item>
                  </NavDropdown>
                </OverlayTrigger>
              </Nav>
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
}

export default HeaderRoles;